import {SET_ADDRESSES, SET_CITIES, SET_COUNTRIES, SET_NEW_OBJECT_ID, SET_OBJECT_TYPES} from "./constans";


let initialState = {

};

const objectAddNewReducers = (state = initialState, action) => {

    switch (action.type) {
        case SET_OBJECT_TYPES:
            return {
                ...state,
                objectTypes: action.payload,
            }
        case SET_COUNTRIES:
            return {
                ...state,
                countries: action.payload,
            }
        case SET_CITIES:
            return {
                ...state,
                cities: action.payload,
            }

        case SET_ADDRESSES:
            return {
                ...state,
                addresses: action.payload,
            }
        default:
            return state;
    }
};


export default objectAddNewReducers;